/**
* Copyright (c) 2015 Ladislav Salom (devhand.com)
*/

$.validator.prototype.showErrorsByElement = function (errors) {
    console.log(errors);
    if ( errors ) {
        // add items to error list and map
        var transformedErrors = {};
        for (var i in errors) {
            transformedErrors[i] = errors[i].error;
        }
        $.extend(this.errorMap, transformedErrors);
        this.errorList = [];
        for ( var name in errors ) {
            this.errorList.push({
                message: errors[name].error,
                element: errors[name].element
            });
        }
        // remove items from success list
        this.successList = $.grep( this.successList, function( element ) {
            return !(element.name in errors);
        });
    } else {
        throw 'errors param is empty';
    }

    if (this.settings.showErrors) {
        this.settings.showErrors.call(this, this.errorMap, this.errorList);
    } else {
        this.defaultShowErrors();
    }
}

/**
* BadRequestCallback
*
* @callback badRequestCallback
* @param {BadRequestResponse} response
*/

/**
* @typedef BadRequestResponse
* @type {Object}
*
* @param {Object} response
*/
function BadRequestResponse(response) {
    var me = this;

    me.getErrorsForProperty = function (propName) {
        return Lazy(response.errors[propName]).map(function(i) { return i.ErrorMessage }).toArray();
    }

    /** @description Zobrazí validační chyby vrácené ze serveru.
    *
    * @param {object} model Model, který je mapovaný na volání serverového API
    * @param {function} keyNotFoundCallback Callback(key, errors), který se volá v případě, že property nebyla na modelu nalezena. Callback by měl vracet true v případě, že zpracoval chybu dle klíče.
    * @param {bool/int[0,1,2]} showCommonErrorForNotProcessed 
     *   - Pokud je false (zpetna kompatibilita) nebo 0, nezobrazí se globální hláška o validační chybě v případě nezpracovaných klíčů.
     *   - pokud je true nebo 1, zobrazi se globalni hlaska
     *   - pokud je 2, zobrazi se error message z api responsu    
    */
    me.showValidationErrors = function (model, keyNotFoundCallback, showCommonErrorForNotProcessed) {
        var notProcessed = [];
        Lazy(response.errors).each(function (error, key) {
            var modelProp = Object.byString(model, key);

            if (modelProp && modelProp.___jqueryValidator) {
                var element = modelProp.___jqueryValidator.element;

                var obj = {};
                obj[key] = { error: error[0].ErrorMessage, element: element };                
                $(element).closest('form').validate({ errorClass: 'input-validation-error' }).showErrorsByElement(obj);
            } else {
                if (keyNotFoundCallback) {
                    if (keyNotFoundCallback(key, error) === true) {
                        notProcessed.push({key: key, error: error});
                    } else {
                        notProcessed.push({key: key, error: error});
                    }
                } else {
                    notProcessed.push({key: key, error: error});
                }
            }
        });

        if (notProcessed.length > 0 && !(showCommonErrorForNotProcessed === false || showCommonErrorForNotProcessed === 0)) {
            if (showCommonErrorForNotProcessed === 2) { //show error from response                
                var customErrors = Lazy(notProcessed).pluck('error').flatten().pluck('ErrorMessage').toArray();
                if (customErrors.length > 0) {
                    //$application.Alerts.ShowError(customErrors.join('. '));
                    console.error(customErrors.join('. '));
                }            
            } else { //default one 
                console.error('Odeslaný požadavek není validní.', notProcessed);
                //$application.Alerts.ShowError('Odeslaný požadavek není validní.');
            }
        }                
    }
}

Object.byString = function (o, s) {
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    s = s.replace(/^\./, '');           // strip a leading dot
    var a = s.split('.');
    for (var i = 0, n = a.length; i < n; ++i) {
        var k = ko.unwrap(a)[i];
        if (k in ko.unwrap(o)) {
            o = ko.unwrap(o)[k];
        } else {
            return;
        }
    }
    return o;
}

/**
*
*
**/
function ApiWrapper() {
    var me = this;

    /**
    * Provede volání API endpointu
    *
    * @param {badRequestCallback} badRequest
    */
    me._apiCall = function (url, method, data, success, badRequest, fail) {
        console.log('Ajax call: ' + url + ', ' + method);

        var dataObj = !$.isEmptyObject(data) ? JSON.stringify(data) : '';

        return $.ajax({
            url: url,
            type: method.toUpperCase(),
            //dataType: 'auto',
            contentType: 'application/json',
            data: dataObj,
            success: function (response, textStatus, jqXhr) {
                if (method.toUpperCase() == "HEAD") {
                    success(true);
                    return;
                }

                success ? success(response, textStatus, jqXhr) : '';
            },
            error: function (response) {
                if (response.status === 0) return; //usually aborting call
                if (method.toUpperCase() == "HEAD") {
                    success(false);
                    return;
                }

                if (response.status == 401) window.location.href = '/account/signin';
                if (response.status == 400) {
                    if (badRequest) badRequest(new BadRequestResponse(response.responseJSON));
                    return;
                }
                if (fail) {
                    fail(response);
                } else {
                    //$application.Alerts.ShowError('Neočekávaná chyba v požadavku ' + url);
                    console.error('Neočekávaná chyba v požadavku ' + url);
                }
            }
        });
    }

    me._createUrl = function (basePath, path, urlParams) {
        var fullPath = basePath + path;
        var regExp = /\{([^\}]+)\}/g;
        var matches = fullPath.match(regExp);
        var finalPath = '';

        var usedParamsInPath = [];

        //urlParams['organizationUri'] = OrganizationUri;

        for (var i in matches) {
            var paramName = matches[i].substring(1, matches[i].length - 1);
            fullPath = fullPath.replace('{' + paramName + '}', urlParams[paramName] ? urlParams[paramName] : '');
            fullPath = fullPath.replace('//', '/');

            //if (urlParams[paramName]) usedParamsInPath.push(urlParams[paramName]);
            usedParamsInPath.push(paramName);
        }

        function serializeParam(key, paramValue) {
            if (Array.isArray(paramValue)) {
                var path = paramValue[0];
                for (var i = 1; i < paramValue.length; i++) {
                    if (paramValue[i]) {
                        path += '&' + key + '=' + paramValue[i];
                    }
                }
                return path;
            } else {
                return paramValue;
            }
        }

        var questMark = false;
        for (var i in urlParams) {
            if ($.inArray(i, usedParamsInPath) == -1) {
                if (typeof urlParams[i] !== 'undefined')  {
                    if (questMark == false) {
                        fullPath += '?';
                        questMark = true;
                    } else {
                        fullPath += '&';
                    }

                    fullPath += i + '=' + serializeParam(i, urlParams[i]);
                }
            }
        }

        return fullPath;
    }

    me._createHandler = function (i, calls, basePath) {
        "use strict";
        /**
        * Provede volání API endpointu
        *
        * @param {badRequestCallback} badRequest
        */
        return function (urlParams, bodyParams, success, badRequest, fail) {
            if (bodyParams) { // probably calling this api
                return me._apiCall(me._createUrl(basePath, calls[i].path, urlParams), calls[i].method, bodyParams, success, badRequest, fail);
            } else { // probably stringifying
                return me._createUrl(basePath, calls[i].path, urlParams);
            }
        }
    }

    me.stringify = function (apiCall, urlParams) {
        return apiCall(urlParams ? urlParams : {});
    }

    me.addController = function (controllerName, basePath, calls) {
        me[controllerName] = {};
        for (var i in calls) {
            me[controllerName][i] = me._createHandler(i, calls, basePath);
        }
    }
}

var $api = new ApiWrapper();

export default $api;